import React from 'react';
import { twMerge } from 'tailwind-merge';
import ApiImage from './ApiImage';
import { getInitialsFromAlias } from '../../../utils/stringUtils';

interface AvatarProps {
  src: string | undefined;
  alias: string;
  className?: string;
}
export default function Avatar({ src, alias, className }: AvatarProps): JSX.Element {
  return src ? (
    <ApiImage
      path={src}
      alt={alias}
      className={twMerge('h-8 w-8 flex-shrink-0 rounded-[8px] object-cover', className)}
    />
  ) : (
    <div
      className={twMerge(
        'flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-[6px] bg-secondary p-1 text-sm text-secondary-50',
        className,
      )}>
      {getInitialsFromAlias(alias)}
    </div>
  );
}
